import React, { Component } from "react"
import $ from 'jquery'
import { inject, observer } from 'mobx-react';
import NavViews from '../../stores/NavViews';
import { Menu, Dropdown, Icon } from 'antd';

@observer(["LeagueStore", "CustomRouter"])
class DropDownCategoryLeagues extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
        };
    }

    async componentWillMount() {
        const { LeagueStore } = this.props;
        let self = this;

        LeagueStore.queryLeagues();

        setTimeout(
            function () {
                self.setState({ loading: false })
            }.bind(self), 250);
    }

    renderLeagues() {
        const { LeagueStore, CustomRouter, categoryId } = this.props;
        const { router: { goTo } } = CustomRouter;

        let leagueList = []
        let leagues = Array.from(LeagueStore.leagues.values());

        for (let league of leagues) {
            if (league.categoryId === categoryId) {
                leagueList.push(
                    <div key={league._id} onClick={() => goTo(NavViews.leagues, { leagueId: league._id }, CustomRouter)} className="category-drop-down-list-item"><span style={{ display: 'inline-block', width: 'auto', margin: '-2px 4px 0px 0px' }}><img style={{ marginBottom: '-5px' }} src={league.logoUrl} /></span> <div style={{ display: 'inline-block' }}> {league.title}</div></div>
                )
            }
        }

        return leagueList;
    }

    render() {
        let league = <Icon type="loading" />

        if (!this.state.loading) {
            league = this.renderLeagues()
        }

        return (
            <div className="category-drop-down-list-wrap">
                <div className="category-drop-down-list">
                    {league}
                </div>
            </div>
        );

    }
}

export default DropDownCategoryLeagues;



// WEBPACK FOOTER //
// ./src/components/layoutComponents/DropDownCategoryLeagues.js